<template>
  <div>
    <GoogleMapLoader
      :mapConfig="mapConfig"
      :apiKey="mapKey">
      <template slot-scope="{google, map}" ref="map">
        <GoogleMapGeofence
          :google="google"
          :map="map" />
      </template>
    </GoogleMapLoader>
  </div>
</template>
<script>
import GoogleMapLoader from '../map/GoogleMapLoader'
import GoogleMapGeofence from '../map/GoogleMapGeofence'
import { mapSettings } from '../../../constants/mapSettings.js'
import config from '../../../../environment.json'
export default {
  name: 'GeofenceMap',
  components: {
    GoogleMapLoader,
    GoogleMapGeofence,
  },
  computed: {
    mapConfig() {
      return {
        ...mapSettings,
        center: this.mapCenter,
      }
    },
    mapCenter() {
      return { lat: 24.0277, lng: -104.653 }
    },
  },
  data() {
    return {
      mapKey: config[process.env.NODE_ENV].mapKey,
    }
  },
  created() {
    // console.log(this.$route.params)
  },
}
</script>
